// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"ber_a bhm_bk bhm_bl bhm_bo","SwipeLeftToClose--animating":"ber_b"};